import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptions } from '@kurtosys/types/query/IQueryOptions.js';
import { IQueryOptionsObject } from '@kurtosys/types/query/options/IQueryOptionsObject.js';

import { helpers } from '../../common/index.js';
import { getQueryClass } from '../queryUtils/getQueryClass.js';

import { BaseQuery } from './base/BaseQuery.js';

export class ObjectQuery extends BaseQuery<IQueryOptionsObject> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}

	getOptions(): IQueryOptionsObject {
		const { fields, options = {} } = this.queryOptions;
		return {
			fields,
			...(options.object || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { fields } = this.queryOptions;
		const response: object = {};
		for (const field of fields) {
			const { name, query } = field;
			if (query) {
				const valueQuery = getQueryClass(this.dependencies, query, this.translationHelper)
				if (valueQuery) {
					const value = valueQuery.execute(executionOptions);
					response[name] = value;
				}
			}
		}
		return response as any as T;
	}
}
